var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmptyKb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-empty-kb",
    transform: "translate(-767 -561)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_135",
    "data-name": "Ellipse 135",
    cx: 60,
    cy: 60,
    r: 60,
    transform: "translate(767 561)",
    fill: "#1a1b43",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3765",
    "data-name": "Group 3765",
    transform: "translate(797 591)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1500",
    "data-name": "Rectangle 1500",
    width: 60,
    height: 60,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(2 5.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3765-2",
    "data-name": "Group 3765"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2439",
    "data-name": "Path 2439",
    d: "M7.622,43.4a2,2,0,0,0,2.634,1.026l10.976-4.824a20.726,20.726,0,0,0,21.63,3.064v0A20.794,20.794,0,1,0,13.754,22.6L2.78,27.418a2,2,0,0,0-1.026,2.636ZM27.742,8.256a16.793,16.793,0,1,1-8.618,22.13A16.708,16.708,0,0,1,27.742,8.256Zm-13.76,18.61a19.8,19.8,0,0,0,4.274,9.68l-7.78,3.418L6.22,30.276Z",
    transform: "translate(-0.416 -2.838)",
    fill: "#1a1b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2440",
    "data-name": "Path 2440",
    d: "M19.184,21.522a2,2,0,1,0,2.37-3.222l-7.1-5.226a2,2,0,1,0-2.37,3.22Z",
    transform: "translate(9.268 7.008)",
    fill: "#1a1b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2441",
    "data-name": "Path 2441",
    d: "M23.18,19.766a2,2,0,0,0,2.37-3.222l-7.1-5.228a2,2,0,0,0-2.37,3.222Z",
    transform: "translate(13.266 5.252)",
    fill: "#1a1b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2442",
    "data-name": "Path 2442",
    d: "M27.176,18.009a2,2,0,0,0,2.37-3.222l-7.1-5.226a2,2,0,1,0-2.37,3.22Z",
    transform: "translate(17.264 3.495)",
    fill: "#1a1b43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2443",
    "data-name": "Path 2443",
    d: "M55,25.162H3a2,2,0,0,0,0,4H55a2,2,0,0,0,0-4Z",
    transform: "translate(-1 19.486)",
    fill: "#1a1b43"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyKb);
export default __webpack_public_path__ + "static/media/icon-empty-kb.5b7b7e554241050b594fe5a2706f0a3d.svg";
export { ForwardRef as ReactComponent };